import React from 'react';

const Logo = ({ className = "h-8", textOnly = false }) => {
  return (
    <div className={`flex items-center ${className}`}>
      {/* Image: Show if NOT textOnly */}
      {!textOnly && (
        <>
          <img
            src="/logo.webp"
            alt="Seven Hats"
            width="767"
            height="141"
            className="h-full w-auto block dark:hidden"
          />
          <img
            src="/logo_white.webp"
            alt="Seven Hats"
            width="767"
            height="141"
            className="h-full w-auto hidden dark:block"
          />
        </>
      )}

      {/* Text: Show if textOnly */}
      {textOnly && (
        <span className="block font-bold text-lg text-charcoal-900 dark:text-white whitespace-nowrap">
          SEVEN HATS®
        </span>
      )}
    </div>
  );
};

export default Logo;
